import { useCallback, useMemo, useState } from "react";

import { getArrayFirstItems } from "../filters";
import { type CountriesStatsItem } from "../models";

export const useHorizontalChartData = (
    data: readonly CountriesStatsItem[],
): {
    metricsList: readonly CountriesStatsItem[];
    seeMoreActive: boolean;
    seeMoreVisible: boolean;
    onClickSeeMore: () => void;
} => {
    const [seeMoreActive, setSeeMoreActive] = useState(false);

    const seeMoreVisible = useMemo(() => data.length > 5, [data]);

    const metricsList = useMemo(
        () => (seeMoreActive ? data : getArrayFirstItems<CountriesStatsItem>(data, 5)),
        [seeMoreActive, data],
    );

    const onClickSeeMore = useCallback(() => {
        setSeeMoreActive(!seeMoreActive);
    }, [seeMoreActive, setSeeMoreActive]);

    return { metricsList, seeMoreActive, seeMoreVisible, onClickSeeMore };
};
